import { unreadNotificationsCountQuery } from '@/entities/notifications';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useUnreadNotifications() {
  const { data } = useAppQuery({
    ...unreadNotificationsCountQuery(),
  });

  return data;
}
